<script>
    import Layout from '../../layouts/main'
    import PageHeader from '@/components/page-header'
    import appConfig from "@/app.config";
    import moment from 'moment';

    export default {
        page: {
            title: "TV Network Usage",
            meta: [
                {
                name: "description",
                content: appConfig.description,
                },
            ],
        },
        components: { Layout, PageHeader },
        data() {
            const current_date = moment().format("YYYY-MM-DD");
            return {
                title: "TV Network Usage",
                items: [
                {
                    text: "TV Network Usage",
                    active: true,
                },                   
                ],

                modal_title: "Add TV",
                button_title: "Save",
                date: current_date,

                clinicTv: {
                    id: "",
                    name: "",
                    username: "",
                    password: "",
                },

                usages: [],
                clinic: {},
                tv_status: {
                    id: "",
                    status: "",
                },
                listing_length: 10,
                keyword: '',
                status: '',
                from: null,
                to: null,
                total: null,
                pagination: {},
                token: "",
                errors: {},
                activate: false,
                deactivate: false,

                change_password: {
                    password: '',
                    password_confirmation: '',
                },
                
                active_page_url: null,
            };
        },
        mounted() {

        },

        created() {
            this.fetchUsages();
        },

        methods: {

            fetchUsages() 
            {
                this.getToken();
                let url = "api/admin/clinics/tvNetworkUsages?clinic_id=" + this.$route.params.id + "&date=" + this.date;
                
                this.loading = true;
                
                this.$axios
                .get(url, { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    console.log(responseData);
                    this.usages = responseData.usages;
                    console.log(this.usages);
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.data.message) {
                            if(typeof error.response.data.message === 'object') {
                            console.log(error.response.status);
                            } else {
                            this.$swal("", error.response.data.message, "error");
                            }                        
                            
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                })
                .finally(() => (this.loading = false));
            }, 

            getToken() {
                if (localStorage.getItem('medicino_admin')) {
                var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
                if(medicino_admin.token) {
                    this.token = medicino_admin.token;
                } else {
                    this.$swal("", "Failed to fetch token, please login again", "error");
                    this.$router.push({ name: "login" });
                }
                
                } else {
                this.$swal("", "Session expired, please login again", "error");
                this.$router.push({ name: "login" });
                }
            }, 

      
            showModal(modal) {
                this.$refs[modal].show();
            },

            hideModal(modal) {
                this.$refs[modal].hide();
            },

            viewContent(content) {
                this.content = content.content;
                this.showModal("content-modal");
            },

        }
    }
</script>
    
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="card-body">
                    <!-- <h4 class="card-title"></h4>
                    <p class="card-title-desc"></p> -->
                    <div class="row mb-2">
                        <div class="col-12">
                            <router-link :to="{ name: 'clinics' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                        </div>
                    </div>

                       <div class="row mb-3">
                     <div class="form-group col-lg-3">
                        <label>Choose Date <span class="text-danger">*</span></label>
                        <!-- <b-form-input type="date" ></b-form-input> -->
                        <input type="date" v-model="date" class="form-control"  @change="fetchUsages" v-bind:class="{ 'is-invalid': Boolean(errors.date) }">
                        <div v-for="(val, index) in errors.date" :key="index" class="invalid-feedback">
                                 <p class="mb-0">{{ val }}</p>
                        </div>
                     </div>
                    
                  </div>

                    <!----- top button area starts---->
                    <!-- <div class="row mb-3">
                        <div class="col-12">                        
                            <b-button v-b-modal.tv-modal variant="primary" class="float-end">Add TV</b-button>
                        </div>
                    </div> -->
                    <!----- top button area ends---->

                    <!----- Listing length and search starts ----->
                    <!-- <div class="row mb-3">
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-length" >
                            <label
                                >Show
                                <select class="form-control" v-model="listing_length" @change="fetchClinicTv()">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                </select>
                                entries
                            </label>
                            </div>                        
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <div class="listing-filter">
                            <label>
                                <input type="text" class="form-control" placeholder="Search" v-model="keyword" @keyup="fetchClinicTv()"/>
                            </label>
                            </div>                     
                            <div class="listing-filter me-2">
                            <label>
                                <select class="form-control" v-model="status" @change="fetchClinicTv()">
                                    <option value="">All</option>
                                    <option value="1">Active</option>
                                    <option value="2">Blocked</option>
                                </select>
                            </label>
                            </div>   
                        </div>
                    </div> -->
                    <!----- Listing length and search ends ----->

                    <!---- listing table starts -------->
                    <div class="table-responsive">
                        <table class="table table-bordered mb-0">

                            <thead class="table-light">
                            <tr>
                                    <th>TV</th>  
                                    <th>Data Usage</th>  
                                    <th>Date</th> 
                                    <th>Updated on</th>
                            </tr>
                            </thead>

                            <tbody v-if="Boolean(usages.length)">
                                <tr v-for="(usage) in usages" :key="usage.id">
                                    <td>{{usage.name}}</td>
                                    <td>{{usage.data_usage}}</td>
                                    <td>{{usage.date| formatDate}}</td>
                                    <td>{{usage.updated_at| formatDateTime}}</td>
                                </tr>
                            </tbody>

                            <tbody v-else>
                            <tr>
                                <td colspan="6" class="text-center">No clinic tv found</td>
                            </tr>
                            </tbody>

                        </table>
                    </div>
                    <!---- listing table ends -------->

                    <!----pagination starts ---> 
                    <!-- <caption v-if="Boolean(clinic_tv.length)" class="float-start mt-4 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>               
                    <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                        <li class="page-item "  v-bind:class="[{disabled: !page.url}, {active: page.active}]" v-for="(page, index) in pagination" :key="page.label">
                            <a href="#" class="page-link" @click.prevent="fetchClinicTv(page.url + '&limit='+ listing_length + '&keyword=' + keyword + '&status=' + status + '&clinic_id=' + $route.params.id )">
                            <i v-if="index == 0" class="mdi mdi-chevron-left"></i>
                            <i v-else-if="index == pagination.length-1" class="mdi mdi-chevron-right"></i>
                            <span v-else>{{page.label}}</span>                          
                            </a>
                        </li>
                    </ul> -->
                    <!----pagination ends --->     
                    
                

                 

                </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
